import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function LoadingBar() {
    return _jsx(_Fragment, { children: "Loading ..." });
}
export function DebugLoadingBar() {
    return (_jsx(_Fragment, { children: _jsx(LoadingBar, {}) }));
}
